module.exports = __webpack_public_path__ + "img/qr-large.20fe5c1b.png";